export const projectData = [
  {
    name: 'pokemon',
    link: 'https://hokkyar.github.io/pokemoon/',
  },
  {
    name: 'movie search',
    link: 'https://hokkyar.github.io/moovie-search/'
  },
  {
    name: 'teenbaster',
    link: 'https://teenbaster.000webhostapp.com/index.php'
  },
  {
    name: 'todo list',
    link: 'https://hokkyar.github.io/todoolist/'
  },
  {
    name: 'linktree',
    link: 'https://hokkyar.github.io/simple-linktree/'
  },
  {
    name: 'digital clock',
    link: 'https://hokkyar.github.io/jam-digital/'
  },
  {
    name: 'suit game',
    link: 'https://hokkyar.github.io/suit-game/'
  },
  {
    name: 'e-company',
    link: 'https://hokkyar.github.io/e-company/'
  },
  {
    name: 'travel guide',
    link: 'https://hokkyar.github.io/travel-guide/'
  },
]
